import { createSelector } from '@reduxjs/toolkit';
import { selectSpecialPromoValue } from './selectSpecialPromoValue';
import { selectAvailablePromo } from 'shared/selectors/specialPromos';

export const selectSpecialPromoFilter = createSelector(
  [selectAvailablePromo, selectSpecialPromoValue],
  (specialPromo, specialPromoValue) => {
    return {
      label: specialPromo?.filterLabel,
      value: specialPromoValue,
      visible: Boolean(specialPromo),
      developerId: specialPromo?.developerId,
    };
  },
);
